export const tableMixins = {
    data() {
        return {
            factoryId: null,
            staffId: null,
            selectedRowKeys: [],
            selectedRows: [],
            pagination: {
                pageSizeOptions: ["10", "20", "30", "40", "50", "60", "100"],
                showSizeChanger: true,
                pageSize: 20,
                total: 0,
                current: 1,
            },
            currentPage: {
                current: 1,
                size: 20,
            },
            bodyStyle: {
                padding: "0 15px 15px",
            },
        };
    },
    mounted() {
        this.factoryId = window.localStorage.getItem("factoryId") || null;
        this.staffId = window.localStorage.getItem("staffId") || null;
    },
    methods: {
        clearSelect() {
            this.selectedRowKeys = [];
            this.selectedRows = [];
        },
        getCheckboxProps(record) {
            return ({
                props: {
                    disabled: this.selectedRowKeys.length >= 20 && !this.selectedRowKeys.includes(record.id)
                },
            });
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            // selectedRowKeys = selectedRowKeys.splice(0,20)
            this.selectedRowKeys = selectedRowKeys;
            let arr = [...this.selectedRows, ...selectedRows];
            this.selectedRows = selectedRowKeys.map((i) => {
                return arr.filter((item) => item.id === i || item.rawId === i)[0];
            });
            if (this.list && this.list.records) this.list.records = [...this.list.records];
        },
        onPageChange(pagination, filters, sorter) {
            console.log(filters, sorter);
            const { current = 1, pageSize: size } = pagination;
            this.currentPage = {
                size,
                current,
            };
            return {
                size,
                current,
            };
        },
        setPagination(pagination) { 
            const { total = 0, current = 1, size } = pagination || {};
            this.pagination.total = total;
            this.pagination.current = current;
            this.pagination.pageSize = size;
        },
        fixedNumber(num, len) {
            return num ? Math.round((num + Number.EPSILON) * len) / len : undefined;
        },
    },
};